var map = {
	"./bridge/bridge_brand_logo.png": "81c9a",
	"./coffeeCup/coffeeCup_brand_logo.png": "4194",
	"./dobby/dobby_brand_logo.png": "c53b",
	"./hermelin/hermelin_brand_logo.png": "b9db",
	"./images/hermelin_brand_logo.png": "5c43",
	"./lacava/lacava_brand_logo.png": "e86e",
	"./selecta/selecta_brand_logo.png": "19c7",
	"./slow/slow_brand_logo.png": "9ea0",
	"./verdi/verdi_brand_logo.png": "ef51"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5bae";